module.exports = __webpack_public_path__ + "static/contests-mail-012aab203e10b6b7068aad00752d468a.png";